import { useEffect } from "react";
import { db, collection, onSnapshot } from "../lib/firebase";
import { usePartyStore } from "../stores/partyStore";
import type { PartyMember } from "../types";

export function useMembersSync(partyId: string | null) {
  useEffect(() => {
    if (!partyId) {
      if (usePartyStore.getState().members.length > 0) {
        usePartyStore.getState().setMembers([]);
      }
      return;
    }

    const membersRef = collection(db, "parties", partyId, "members");

    const unsubscribe = onSnapshot(
      membersRef,
      (snapshot) => {
        const membersList: PartyMember[] = snapshot.docs.map((docSnap) => {
          const data = docSnap.data();
          return {
            uid: docSnap.id,
            name: data.name || "Guest Singer",
            photoURL: data.photoURL || `https://api.dicebear.com/7.x/bottts/svg?seed=${docSnap.id}`,
            role: data.role || "GUEST",
            isAnonymous: data.isAnonymous ?? false,
            joinedAt: data.joinedAt || Date.now(),
          };
        });

        // Host first, then alphabetical
        membersList.sort((a, b) => {
          if (a.role === "HOST") return -1;
          if (b.role === "HOST") return 1;
          return a.name.localeCompare(b.name);
        });

        usePartyStore.getState().setMembers(membersList);
      },
      (error) => {
        if (error.code !== "permission-denied") {
          console.error("Members sync error:", error);
        }
      }
    );

    return () => unsubscribe();
  }, [partyId]);
}
